export const viewDcrsPageStyles = {
	layout: {
		width: '100%'
	},
	root: {
		display: 'flex',
		flexDirection: 'column',
		borderRadius: 1,
		width: '100%',
		backgroundColor: 'background.paper',
		pt: 2,
		gap: 2
	},

	nameCell: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		height: '100%',
		gap: 1
	},

	attachmentsCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		color: 'text.secondary'
	},

	datagrid: {
		border: 0,

		'.MuiDataGrid-overlayWrapper': {
			height: 'auto !important'
		},
		'.MuiDataGrid-overlayWrapperInner': {
			height: 'auto !important'
		},
		'& .MuiDataGrid-columnHeaderTitle': {
			fontWeight: 700,
			userSelect: 'none'
		},
		'& .MuiDataGrid-columnHeaders': {
			borderColor: 'divider',
			borderBottomWidth: 2
		},
		'& .MuiDataGrid-cell': {
			borderColor: 'divider'
		},
		'& .MuiDataGrid-columnSeparator': {
			color: 'divider',
			opacity: '1 !important'
		},
		// Hide right separator of attachments paperclip column only.
		'& .MuiDataGrid-columnHeader[data-field="attachments"] .MuiDataGrid-columnSeparator':
			{
				display: 'none'
			},
		'& .MuiDataGrid-row': {
			cursor: 'pointer'
		},
		'& .MuiDataGrid-row.row-disabled': {
			cursor: 'auto'
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor: 'primary.hover'
		},
		'& .MuiDataGrid-row.row-disabled:hover': {
			backgroundColor: 'unset'
		},
		'& .MuiDataGrid-cell:focus': {
			outline: 'none'
		},
		'& .MuiDataGrid-cell:focus-within': {
			outline: 'none'
		},
		'& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus-visible':
			{
				outline: 'none !important'
			}
	},

	filterBox: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: { xs: 'stretch', sm: 'flex-start' },
		gap: 2,
		marginTop: 3
	},

	searchBar: {
		root: {
			flex: { xs: '0 0 auto', sm: '1 1 300px' },
			width: { xs: '100%', sm: 'auto' },
			minWidth: { xs: 0, sm: 200 },
			maxWidth: { xs: '100%', sm: 360 }
		}
	},

	sectionBlockCustomSx: (isInitialLoading: boolean) => ({
		section: {
			height: isInitialLoading ? 700 : 'unset'
		}
	})
};
